import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { OosSelectionContent } from "../components/OosSelectionContent";
import { useFetchJobTasks } from "@labeling-tools/api/lebron/react-query-hooks";
import { useFetchTask } from "@labeling-tools/api/lebron/react-query-hooks";
import { useNavigate } from "react-router-dom";
import { LoadingOverlay } from "@mantine/core";
import { useAppDispatch } from "../store/hooks";
import { Match, reset, setMatches } from "../store";
import { AdminToolbar } from "../components/AdminToolbar";
import { HEADER_HEIGHT, RESULTS_SIDEBAR_WIDTH } from "@/config/data";
import { SelectionResultsSidebar } from "../components/SelectionResultsSidebar";
import { isEmpty } from "lodash";

export const AdminOosSelection = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { jobId } = useParams();
  const [searchParams] = useSearchParams();
  const taskId = searchParams.get("taskId");

  const { data: jobTasks, isLoading: jobTasksLoading } = useFetchJobTasks(
    jobId || "",
  );
  const { data: task, isLoading: taskLoading } = useFetchTask(
    jobId || "",
    taskId || jobTasks?.tasks[0]?.id,
  );

  // default to first task if no taskId is in url
  useEffect(() => {
    if (task) {
      dispatch(setMatches(task?.result?.matches as Match[]));
    }
    if (task && !taskId) {
      navigate(
        `/jobs/${jobId}/admin-selection?taskId=${jobTasks?.tasks[0]?.id}`,
        { replace: true },
      );
    }
  }, [task]);

  // Set matches when task is loaded
  useEffect(() => {
    if (task && taskId) {
      dispatch(setMatches(task?.result?.matches as Match[]));
    }
  }, [task, taskId]);

  // Reset Redux state when component unmounts
  useEffect(() => {
    return () => {
      dispatch(reset());
    };
  }, [dispatch]);

  if (jobTasksLoading || taskLoading) {
    return <LoadingOverlay visible={true} />;
  }
  const hasResults = !!task?.result && !isEmpty(task.result);
  return (
    <div style={{ paddingTop: HEADER_HEIGHT }}>
      {/* admin toolbar */}
      {jobTasks && task && (
        <AdminToolbar jobTasks={jobTasks} activeTask={task} />
      )}

      {/* main content */}
      <div className={hasResults ? `pr-[${RESULTS_SIDEBAR_WIDTH}px]` : ""}>
        <OosSelectionContent mode="admin" />
      </div>

      {/* results sidebar */}
      {hasResults && <SelectionResultsSidebar task={task} />}
    </div>
  );
};
